import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { productSummaryGraphsQueries } from '../queries/productSummaryGraphsQueries';
import {
  getProductSummarySubscriptionStatus,
  PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS,
} from '../api/productSummaryGraphsApi';
import { getPieColors } from 'src/common/components/Graphs/common/Graphs/utils/doughnut';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

type UseProductsSummarySubscriptionStatusDataProps = {
  tariffCode: string | null;
};

export const useProductsSummarySubscriptionStatusData = ({
  tariffCode,
}: UseProductsSummarySubscriptionStatusDataProps) => {
  const { palette } = useTheme();
  const { t } = useTranslation();

  const { data } = useSuspenseQuery({
    queryKey: productSummaryGraphsQueries.subscriptionStatus(tariffCode),
    queryFn: () => setMinimalPromiseTime(getProductSummarySubscriptionStatus({ tariffCode })),
  });

  const subscriptionStatusData = useMemo(
    () => ({
      labels: [
        t('dashboard.subscriptionsStatusChart.legend.test'),
        t('dashboard.subscriptionsStatusChart.legend.active'),
        t('dashboard.subscriptionsStatusChart.legend.deactivated'),
      ],
      dataset: {
        data: [
          data.data[PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS.TEST],
          data.data[PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS.ACTIVE],
          data.data[PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS.DEACTIVATED],
        ],
        ...getPieColors([palette.blue, palette.green, palette.red]),
      },
    }),
    [t, data],
  );

  return { chartData: subscriptionStatusData, total: data.total };
};
